import gql from 'graphql-tag';

export default gql`
  mutation updateVisitorPassStatus(
    $visitorPassId: UUID!
    $status: String!
    $organizationId: String!
  ) {
    updateVisitorPassStatus(
      visitorPassId: $visitorPassId
      status: $status
      organizationId: $organizationId
    ) {
      id
    }
  }
`;
